import { HttpClient } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { AppConfig } from '../app.config';
import { Level, Logger } from './logger';

@Injectable()
export class LoggerFactory {
    private maxLoggingLevel: Level = Level.Warning;
    private loggers: Logger[];

    constructor(private http: HttpClient, private appConfig: AppConfig) {
        this.loggers = [];
    }

    public create(name: string) {
        let logger = new Logger(name, this.maxLoggingLevel, this.http, this.appConfig);
        this.loggers.push(logger);
        return logger;
    }

    public setMaxLoggingLevel(level: Level) {
        this.maxLoggingLevel = level;

        for (let logger of this.loggers) {
            logger.setMaxLoggingLevel(level);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/loggerFactory.ts